import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { AccountPage } from "@/features/onboarding/pages/account-page";

export const Route = createFileRoute("/onboarding/account")({
	head: () => pageTitle("Create your account"),
	component: AccountPage,
});
